import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { PerformanceSummary } from '@/hooks/usePartnerAnalytics';
import { PrequalificationStatusBadge } from '@/components/partners/PrequalificationStatusBadge';
import { AlertTriangle } from 'lucide-react';
import { format } from 'date-fns';

interface ExpiringContractorsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contractors: PerformanceSummary[];
}

export function ExpiringContractorsDialog({ open, onOpenChange, contractors }: ExpiringContractorsDialogProps) {
  const expiring = contractors.filter(c => 
    c.prequalification_status === 'expiring_soon' || c.prequalification_status === 'expired'
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            Expiring Contractors ({expiring.length})
          </DialogTitle>
        </DialogHeader>

        <div className="overflow-auto flex-1">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Contractor</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Last Document Upload</TableHead>
                <TableHead className="text-right">Pending</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {expiring.map((contractor) => (
                <TableRow key={contractor.id}>
                  <TableCell className="font-medium">{contractor.name}</TableCell>
                  <TableCell>
                    <PrequalificationStatusBadge status={contractor.prequalification_status} />
                  </TableCell>
                  <TableCell>
                    {contractor.last_document_upload 
                      ? format(new Date(contractor.last_document_upload), 'MMM dd, yyyy')
                      : 'Never'
                    }
                  </TableCell>
                  <TableCell className="text-right">
                    {contractor.pending_documents > 0 ? (
                      <span className="text-yellow-600 font-medium">{contractor.pending_documents}</span>
                    ) : (
                      <span className="text-muted-foreground">-</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
